module.exports = __webpack_public_path__ + "img/icon-ppt.3ab3b5c0.svg";